import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { TRANSACTION_REPORT_TIMEZONES } from './TransactionTimeRangeFilter';

export const FacilityTimezoneFilter = ({
	value,
	onChange,
}: {
	value: string;
	onChange: (timezone: string) => void;
}) => (
	<FormControl fullWidth>
		<InputLabel id='facility-report-timezone-label'>Timezone</InputLabel>
		<Select
			labelId='facility-report-timezone-label'
			label='Timezone'
			value={value}
			onChange={(event) => onChange(event.target.value)}
		>
			{TRANSACTION_REPORT_TIMEZONES.map((timezone) => (
				<MenuItem key={timezone.value} value={timezone.value}>
					{timezone.label}
				</MenuItem>
			))}
		</Select>
	</FormControl>
);
